import { render, staticRenderFns } from "./classMange.pug?vue&type=template&id=0af1b2fc&scoped=true&lang=pug&"
import script from "./classMange.ts?vue&type=script&lang=ts&"
export * from "./classMange.ts?vue&type=script&lang=ts&"
import style0 from "./classMange.styl?vue&type=style&index=0&id=0af1b2fc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af1b2fc",
  null
  
)

export default component.exports